// extracted by mini-css-extract-plugin
module.exports = {"mtoDispatch__info":"styles_mtoDispatch__info__FvVfo","mtoDispatch__message":"styles_mtoDispatch__message__BA7Ow"};